document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.getElementById('variant-description-wrapper');
  const contents = wrapper ? wrapper.querySelectorAll('.variant-description-content') : [];
  const drawingLink = document.querySelector('[data-technical-drawing-link]');
  const drawingVariants = document.querySelector('[data-variant-technical-drawings]');

  const showDescription = (id) => {
    contents.forEach((el) => {
      el.style.display = el.dataset.variantId === String(id) ? '' : 'none';
    });
  };

  const showTechnicalDrawing = (id) => {
    if (!drawingLink || !drawingVariants) return;

    const variant = drawingVariants.querySelector(`[data-variant-id="${String(id)}"]`);
    const url = (variant && variant.dataset.technicalDrawing) || drawingLink.dataset.productTechnicalDrawing;
    drawingLink.hidden = !url;
    drawingLink.setAttribute('href', url || '');
  };


  if (window.globalVariantId) {
    showDescription(window.globalVariantId);
    showTechnicalDrawing(window.globalVariantId);
  }

  document.addEventListener('globalVariantIdUpdated', (e) => {
    showDescription(e.detail.variantId);
    showTechnicalDrawing(e.detail.variantId);
  });
});